import { useEffect, useState } from "react";
import { Clock } from "lucide-react";

const DATE_FMT = new Intl.DateTimeFormat(undefined, {
  weekday: "short",
  day: "2-digit",
  month: "short",
  year: "numeric",
});
const TIME_FMT = new Intl.DateTimeFormat(undefined, {
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit",
  hour12: true,
});
const COMPACT_TIME_FMT = new Intl.DateTimeFormat(undefined, {
  hour: "2-digit",
  minute: "2-digit",
  hour12: true,
});
const COMPACT_DATE_FMT = new Intl.DateTimeFormat(undefined, {
  day: "2-digit",
  month: "short",
});

function useTick() {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);
  return now;
}

export default function HeaderClock() {
  const now = useTick();
  return (
    <div
      className="inline-flex items-center gap-2 px-3 h-9 rounded-full bg-slate-50 dark:bg-slate-800 border border-slate-200 dark:border-slate-700"
      data-testid="header-clock"
      title={now.toString()}
    >
      <Clock className="h-3.5 w-3.5 text-sky-500" />
      <span className="hidden lg:inline text-xs font-medium text-slate-700 dark:text-slate-200" data-testid="header-date">
        {DATE_FMT.format(now)}
      </span>
      <span className="hidden lg:inline h-3 w-px bg-slate-300 dark:bg-slate-600" />
      <span
        className="text-xs font-mono tabular-nums text-slate-900 dark:text-slate-100"
        data-testid="header-time"
      >
        {TIME_FMT.format(now)}
      </span>
    </div>
  );
}

export function MobileClock() {
  const now = useTick();
  return (
    <div
      className="flex items-center gap-1.5 px-3 py-1.5 rounded-full text-xs whitespace-nowrap bg-sky-50 dark:bg-sky-900/40 text-sky-700 dark:text-sky-300"
      data-testid="header-clock-mobile"
      title={now.toString()}
    >
      <Clock className="h-3.5 w-3.5" />
      <span className="font-medium">{COMPACT_DATE_FMT.format(now)}</span>
      <span className="font-mono tabular-nums">{COMPACT_TIME_FMT.format(now)}</span>
    </div>
  );
}
